import { css } from "@emotion/css";
import styled from "@emotion/styled";
import { Colors, Modal, Spacing } from "@snapchat/snap-design-system";

import { appearingAnimation, detailsControl } from "../../../../shared/styles";

export const scanCodeControl = css`
    ${detailsControl};
    margin-block-start: ${Spacing.MD + Spacing["2XS"]}px;
    padding-bottom: 0;
`;

export const ScanCodeTrigger = styled.button`
    cursor: pointer;

    margin: 0;
    padding: 0;

    line-height: 0;

    background: none;
    border: none;
    outline: 1px;
`;

export const ScanCodeTriggerImage = styled.img`
    width: 64px;
    height: 64px;
    animation: ${appearingAnimation} 180ms ease;
`;

export const ScanCodeImage = styled.img`
    max-width: 90vw;
`;

// QR codes need a light quiet zone to scan over the modal's dark mask.
export const QrCodeImage = styled(ScanCodeImage)`
    padding: ${Spacing.MD}px;
    background-color: ${Colors.WHITE};
`;

export const ScanCodeModal = styled(Modal)`
    .ant-modal-body {
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .ant-modal-content {
        background-color: transparent;
        border-radius: 0;
        box-shadow: none;
    }
`;

export const AddButtonContainer = styled.div`
    animation: ${appearingAnimation} 200ms ease;

    > .sds-base-button.ant-btn.circle {
        min-width: 28px;
        min-height: 28px;
        margin-left: 8px;
        color: ${Colors.Black.V50};
    }
`;
